// extracted by mini-css-extract-plugin
export default {"body":"Menu_body__n9ldo","menu":"Menu_menu__8DS-I","backHead":"Menu_backHead__xg38s","list":"Menu_list__6ikx7","login":"Menu_login__pMxm9"};